module.exports = __webpack_public_path__ + "img/Slide0.42433759.png";